export default "__VITE_ASSET__Bx1dc0Vz__"